import { IItemOrcamento } from 'app/types/IItemOrcamento';
import React from 'react'

import { v4 as uuidv4 } from 'uuid';

type ListaItensOrcamentoProps = {
    itensOrcamento: IItemOrcamento[]
}

const ListaItensOrcamento = (props:ListaItensOrcamentoProps) => {
    return (
        <>
            <h4>
                Itens em React
            </h4>

            {(props.itensOrcamento || []).map(item => <div key={uuidv4()}>
                {item.ListEstoqueProduto?.Descricao}
            </div>)}
            
        </>
    )
}

export {
    ListaItensOrcamento
}

